import _ from 'lodash';
import React, { useContext } from 'react';
import { FrameworkContext } from '../cnr/contexts/FrameworkContent';
import { GoogleSheetsContext } from '../cnr/contexts/GoogleSheetsContext';
import { frameworkRightTypes } from '../cnr/reducers/FrameworkReducer';
import { GoogleDashboard } from '../components/viewers/GoogleDashboard';
import TreeViewer from '../components/viewers/TreeViewer';
import { clickOriginTypes } from '../enums/globalEnums';
import Wrapper, { wrapperTypes } from '../wrappers/Wrapper';
import AppUserManager from '../appUsers/AppUserManager';
import { LogContext } from 'global/cnr/contexts/LogContext';
import { Icon } from 'semantic-ui-react';

const AppSettingsSidebarWithProvider = React.lazy(() => import('../viewSettings/AppSettingsSidebar'));
const DataLinkingSidebar = React.lazy(() => import('../viewSettings/data/DataLinkingSidebar'));
const GoogleDashboardWithProvider = React.lazy(() => import('../components/viewers/GoogleDashboard'));
const ItemDataSidebar = React.lazy(() => import('../viewSettings/data/ItemDataSidebar'));
const MediaDataSidebar = React.lazy(() => import('../viewSettings/data/MediaDataSidebar'));
const SettingsFormSidebar = React.lazy(() => import('../viewSettings/data/SettingsFormSidebar'));
const UiDataModifications = React.lazy(() => import('../pageItem/modification/UiDataModifications'));

const PageFrameworkRight = (props) => {

  const { showLeftSettings } = props

  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { frInfo, frContent, _appSettingsOn, frameworkRightType, dataModifyType } = framework_state ?? {}
  const { viewListData } = frInfo ?? {}

  // logContext
  const logContext = useContext(LogContext)
  const { log_state, log_handlers } = logContext ?? {}
  const { logs } = log_state ?? {}

  // googleSheetsContext
  const googleSheetsContext = useContext(GoogleSheetsContext)
  const { googleSheets_state } = googleSheetsContext ?? {}

  const clearLog = () => log_handlers.clearLogs()

  switch (frameworkRightType) {
    case frameworkRightTypes.settings:
      return <AppSettingsSidebarWithProvider isGlobal={false} showRightSettings={true} />

    case frameworkRightTypes.sportScoresViewer:
      return <Wrapper
        header={'frContent'}
        content={frContent}
        css={{ container: 'app-dark-mode' }}
        wrapperType={wrapperTypes.padded}
      ></Wrapper>

    case frameworkRightTypes.showLog:
      const lis = _.map(logs, (log) => (
        <div>{log.message}</div>
      ))
      return <Wrapper
        header={<div style={{ display: 'flex', justifyContent: 'space-between' }}><div>Logs</div><div><Icon name='delete' onClick={(e) => { clearLog(e) }} /></div> </div>}
        content={<div style={{ fontSize: '.8rem', display: 'flex', flexDirection: 'column', rowGap: '.5em' }}>{lis}</div>}
        css={{ container: 'app-dark-mode' }}
        wrapperType={wrapperTypes.padded}
      ></Wrapper>

    case frameworkRightTypes.showDataJson:
      return <Wrapper
        header={'Data'}
        content={<TreeViewer data={viewListData} scNames={true} subNames={true} />}
        css={{ container: 'app-dark-mode' }}
        wrapperType={wrapperTypes.padded}
      ></Wrapper>

    case frameworkRightTypes.pageSettingsFull:
      return _appSettingsOn && <AppSettingsSidebarWithProvider showLeftSettings={showLeftSettings} />

    case frameworkRightTypes.pageDataAdd:
    case frameworkRightTypes.pageDataEdit:
    case frameworkRightTypes.pageSettings:
      return <ItemDataSidebar />

    case frameworkRightTypes.pageLinkData:
      return <DataLinkingSidebar />

    case frameworkRightTypes.dataConstraints:
    case frameworkRightTypes.display:
    case frameworkRightTypes.props:
      return <SettingsFormSidebar settingsType={frameworkRightType} />

    case frameworkRightTypes.filters:
      return <div>Filter</div>

    case frameworkRightTypes.pageMedia:
      return <MediaDataSidebar />

    case frameworkRightTypes.appUserProfile:
      return <Wrapper
        header={'App User'}
        content={
          <AppUserManager selectedAppUser={_.head(_.values(viewListData))} clickOriginType={clickOriginTypes.sidebar} />
        }
        wrapperType={wrapperTypes.padded}
      ></Wrapper>
      return

    case frameworkRightTypes.google:
      const { googleSheetsData } = googleSheets_state ?? {}
      return googleSheetsData ? <GoogleDashboard /> : <GoogleDashboardWithProvider />

    case frameworkRightTypes.dataModification:
    case frameworkRightTypes.filters:
    case frameworkRightTypes.sorting:
      let header;
      const { captions } = frInfo ?? {}
      const { add, edit } = captions ?? {}
      switch (dataModifyType) {
        case 'add':
          header = add
          break;
        case 'edit':
          header = edit
          break;
        case 'sorting':
          break;
        default:
          header = _.startCase(dataModifyType)
      }

      const rcContent = frameworkRightType && <UiDataModifications
        clickOriginType={clickOriginTypes.dataViewer}
        dataModificationDisplayType={'direct'}
        modifyActionType={dataModifyType}
        frameworkRightType={frameworkRightType}
      />

      return <Wrapper
        header={header}
        content={rcContent}
        wrapperType={wrapperTypes.paddedHeader}
      />
    default:
    // nothing
  }

  return <div>{frameworkRightType}</div>;

}

export default PageFrameworkRight
